<div class="DPContainer" id="DPContainer">

   <!---------------------//draw levels ------------------------>
   <div class="level" *ngFor="let level of DungeonPathService.levelList">
      <!-- <div *ngIf="DungeonPathService.showDevInfo == true"> -->
      <!-- Level {{ this.level.levelNo }} -->
      <!-- </div> -->
      <!---------------------//draw rooms ------------------------>
      <div *ngFor="let room of level.roomList" attr.id="Location{{room.roomID}}">

         <!-- draw a random gap -->
         <div *ngIf="room.roomNo === 0">
            <div [ngClass]="{'randomgap': DungeonPathService.showDevInfo === true}"
               *ngIf="DungeonPathService.showDevInfo == true">
               <p> lv {{room.levelNo}} rm {{room.roomNo}} tp {{ room.roomType }}</p>
            </div>
         </div>

         <!-- draw a room -->
         <div class="flexrow">

            <div class="room" *ngIf="room.roomNo !== 0">

               <div *ngIf="DungeonPathService.showDevInfo === true && room.roomNo !== 0">
                  lv {{room.levelNo}} <br>
                  rm {{room.roomNo}}<br>
                  {{room.roomID}}<br>
                  {{room.conxType}}
                  {{room.roomType}}
               </div>

               <button
                  *ngIf="room.roomID === (DungeonPathService.nextID1) || room.roomID === (DungeonPathService.nextID2)"
                  class="rmButton" id="button" (click)="movePlayer(room.roomID)">
               </button>

               <div class="player" *ngIf="room.roomID === DungeonPathService.posID">
                  <img class="playerIcon" src="assets/images/avatars/ManIcon2.png">
               </div> 

               <div *ngIf="DungeonPathService.showDevInfo === false && room.roomNo !== 0">
                  <span *ngIf="room.roomType === 'start'">
                  </span>
                  <span *ngIf="room.roomType === 'monster'" class="iconify" data-icon="ri-skull-2-line"
                     data-inline="false">
                  </span>
                  <span *ngIf="room.roomType === 'boss'" class="iconify" color="orange" data-icon="ri-skull-2-line"
                     data-inline="false"></span>
                  <span *ngIf="room.roomType === 'finalboss'" class="iconify" color="red" data-icon="ri-skull-2-line"
                     data-inline="false"></span>
                  <span *ngIf="room.roomType === 'treasure'" class="iconify" color="gold" data-icon="mdi-treasure-chest"
                     data-inline="false"></span>
                  <span *ngIf="room.roomType === 'fire'" class="iconify" color="red" data-icon="majesticons:fire"
                     data-inline="false"></span>
               </div>
               <div *ngIf="room.used === true" class="used"></div>
               <div class="nextroominfo" *ngIf="DungeonPathService.showDevInfo === true && room.roomNo !== 0">
                  {{room.conxRm1}} <br>
                  {{room.conxRm2}}
               </div>
            </div>

         </div>



      </div>



   </div>